import { MarkedOptions } from 'ngx-markdown';

/**
 * Base marked configuration with common settings used across all markdown renderers.
 * This ensures consistent behavior for GitHub Flavored Markdown and line breaks.
 */
export const BASE_MARKED_CONFIG: Pick<MarkedOptions, 'gfm' | 'breaks'> = {
  gfm: true,
  breaks: true,
};

/**
 * Creates marked options by merging base configuration with custom options.
 * This ensures all renderers use consistent base settings while allowing customization.
 */
export function createMarkedOptions(customOptions: Partial<MarkedOptions> = {}): MarkedOptions {
  return {
    ...BASE_MARKED_CONFIG,
    ...customOptions,
  };
}
